var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('b-badge',{staticClass:"badge-lg badge-no-bold",attrs:{"variant":_vm.badgeVariant}},[_vm._v(" "+_vm._s(_vm._f("vaeSurveillanceType")(_vm.surveillanceType))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }